import React, { useContext, useEffect, } from 'react'
import styles from '../styles.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { getClassbook, getLessonChart, getClassTopic } from '../../../actions/classbook'
import { ClassbookContext } from '../../../utils/context'
import Table from '../../../components/Table'
import { getStudentsForGeneralInfo } from '../../../actions/students/list'


export default function GeneralInfo() {

    const dispatch = useDispatch()
    const { formData } = useContext(ClassbookContext)
    const { students_list, expelled_students } = useSelector(state => state.classbook)

    useEffect(() => {
        const { year, period } = formData
        dispatch(getStudentsForGeneralInfo(formData))
    }, [])

    const handleSearch = () => {
        dispatch(getClassbook(formData));
        dispatch(getLessonChart(formData));
    }

    const handleClassTopic = (year, sheid) => {
        dispatch(getClassTopic(year, sheid));
    }

    const renderLi = (data) => {
        const { fio, document_issue_date, sex, snils, login } = data
        return (
            <tr>
                <td>{fio}</td>
                <td>{document_issue_date}</td>
                <td>{sex}</td>
                <td>{snils}</td>
                <td>{login}</td>
            </tr>
        )
    }
    return (
        <Table className={styles.tables}>
            <thead>
                <tr>
                    <th>Фио</th>
                    <th>Дата рождения</th>
                    <th>Пол</th>
                    <th>Удостоверение</th>
                    <th>Email</th>

                    <th></th>
                </tr>
            </thead>
            <tbody>
                {students_list?.map(renderLi)}
            </tbody>
        </Table>
    )
}
